import React from 'react';
import PropTypes from 'prop-types';
import { v as bvVar } from 'bv';
import classNames from 'classnames';
import { partnerLogos, showLogo, showPartners } from 'footer-config';

import Ambassador from './ambassador';
import PartnerLogos from './partner_logos';

const {
  footerLinks,
  snippet,
  logos,
} = bvVar('footerSettings');

const ambassador = bvVar('ambassador');

const SiteFooter = ({ className, tagName: Tag }) => (
  <Tag className={`site-footer${className ? ` ${className}` : ''}`}>
    {showLogo && <div className={classNames('bvs-site-logo--footer', className)} />}
    {ambassador && <Ambassador hasBackground={false} />}
    {showPartners && partnerLogos.length && <PartnerLogos />}
    <nav>
      <ul className="id-homepage_footer">
        <li className="id-homepage_footer_ts_and_cs">
          {footerLinks.map(({ url, title }) => (
            <a href={url} className="static-page">{title}</a>
          ))}
        </li>
        <li
          className="id-homepage_footer_info"
          dangerouslySetInnerHTML={{ __html: snippet }}
        />
        <li className="id-homepage_footer_logos">
          {logos.map(({ class: logoClassName, href, ...rest }) => (
            <a href={href} className={logoClassName} {...rest} />
          ))}
        </li>
      </ul>
    </nav>
  </Tag>
);

SiteFooter.propTypes = {
  className: PropTypes.string,
  tagName: PropTypes.string,
};

SiteFooter.defaultProps = {
  className: '',
  tagName: 'footer',
};

export default SiteFooter;
